import { render, staticRenderFns } from "./BlockchainInformation.vue?vue&type=template&id=2ea4e5a1&scoped=true"
import script from "./BlockchainInformation.vue?vue&type=script&lang=js"
export * from "./BlockchainInformation.vue?vue&type=script&lang=js"
import style0 from "./BlockchainInformation.vue?vue&type=style&index=0&id=2ea4e5a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4e5a1",
  null
  
)

export default component.exports